module.exports = __webpack_public_path__ + "img/payu.bbc3b885.svg";